module.exports = require("next/router");


//////////////////
// WEBPACK FOOTER
// external "next/router"
// module id = next/router
// module chunks = 3